import { unionLoginOrRegister, findChinaPostOrgUnitApi ,getUserInfoApi ,getEntListApi,updateUserOrgInfoApi} from '@/libs/api';
import { uleUrl } from "@/libs/common";
export default {
    name: "userCenter",
    components: {},
    data() {
        return {
            show:false,//是否展示机构确认弹窗
            entPop:false,//企业选择层
            isShowMec: false,// 是否显示机构信息选择层
            entList:[],//企业列表
            popList: [],//机构列表
            seceltEntData:{},//待确认企业
            user:{},
            hasNext: true,// 是否有下一级机构
            parentName: '',// 上一级机构名称
            // 提交接口的数据
            query: {
                orgType: "0",//默认中国邮政集团公司
                currentEntName:'中国邮政集团公司',
                nextOrgType: "0",
                orgProvince: "",
                orgCity: "",
                orgArea: "",
                orgTown: "",
            },
            popText: "所属机构",
            popPage: 0, // 机构当前等级
            popPageHis: 0,//打开弹窗时机构等级
            // 页面显示机构数据
            orgInfo: {
                orgType: "",
                nextOrgType: "0",
                orgProvince: "",
                orgCity: "",
                orgArea: "",
                orgTown: "",
                currentId: "",
                currentName: "",
                mecName: "请选择机构",
            },
        };
    },
    created() { },
    mounted() {
        this.unionLogin({
            bscInfo: this.$route.query.bscInfo,
            sign: this.$route.query.sign,
            operateOrg: false
        })
    },
    methods: {
        isOpenEntPop(){//选择企业
            this.entPop = !this.entPop
        },
        selectEnt(ent){//选择企业
            this.entList.forEach(item => {
                item.checked = ent.id == item.id;
                if(item.checked){
                    this.seceltEntData = ent
                }
            });
        },
        updateEnt(){//更新企业选择
            if(this.seceltEntData.id){
                this.query.orgType = this.seceltEntData.id
                this.query.nextOrgType = this.seceltEntData.orgType
                this.query.currentEntName = this.seceltEntData.name
                this.seceltEntData = {}
            }
            this.isOpenEntPop()
        },
        isOpenOrgPop(){//选择机构
            if(!this.query.currentEntName){
                this.$toast('请先选择企业');
                return;
            }
            this.openPop()
            this.isShowMec = !this.isShowMec;
        },    
        unionLogin(data) {//联合登录
            unionLoginOrRegister(data).then((res) => {
                if (res.returnCode == '0700') {//未注册
                    this.getEntList()
                    return;
                }
                //登录失败的其他场景
                else if (res.returnCode !== '0000') {
                    this.$toast(res.returnMessage);
                    return;
                }else{
                    this.$cookies.set('ul_union', res.data.ul_union, 14 * 24 * 3600, '/', '.'+ uleUrl());
                    getUserInfoApi().then((data)=>{//获取用户信息
                        if(data.returnCode == '0000' && data.data && data.data.lastOrgId && data.data.lastOrgId != '58093'){
                            location.href = `https://h5.${uleUrl()}/hd/yxd/jielong/list.html?adid=bsc_qiyewx_community&lowestOrgCode=${data.data.lastOrgId}&storeid=${data.data.usrOnlyid}&ul_union=${res.data.ul_union}`
                        }else{
                            this.user = data.data || {};
                            this.getEntList()
                        }
                    })
                }
            })
        },
        getEntList(){//获取企业列表
            getEntListApi().then((data)=>{
                if(data.returnCode == '0000'){
                    data.data.forEach(li => {
                        if (li.id == '100') {
                            li.orgType = '0'
                        }else{
                            li.orgType = '2'
                        }
                        li.checked = false;
                        if(this.user.orgType == li.id || (!this.user.orgType && li.id == '100') || (this.user.orgType == 0 && this.user.lastOrgId == '58093' && li.id == '100')){
                            li.checked = true;
                            this.query.currentEntName = li.name
                            this.query.nextOrgType = li.orgType
                            this.query.orgType = li.id
                        }
                    });
                    this.entList = data.data;
                    this.show = true;
                }
            })
        },
        async openPop() {
            this.popList = [];
            this.hasNext = true;
            this.parentName = this.orgInfo.mecName || '全国';
            this.popList = await this.findChinaPostOrgUnit(
                '100',
                this.query.nextOrgType
            );
            this.popPageHis = this.popPage = 0;
            this.isShowMec = true;
        },
        // 关闭弹层
        closePop() {
            this.popPage = this.popPageHis = 0;
            this.isShowMec = false;
        },
        // 获取下级机构信息
        findChinaPostOrgUnit(parentId, nextOrgType) {
            return findChinaPostOrgUnitApi({ parentId, orgType: nextOrgType }).then(
                (res) => {
                    let list = res.data;
                    list.forEach((ele) => {
                        this.$set(ele, "checked", false);
                    });
                    return list;
                }
            );
        },
        //返回上一机构
        async prevPage() {
            this.popPage--;
            if (this.popPage == 0) {
                this.popText = "所属机构";
            } else {
                this.popText = "所选机构";
            }
            let parentId = "";
            switch (this.popPage) {
                case 0:
                    this.query.orgProvince = this.query.orgCity = this.query.orgArea = this.query.orgTown = ''
                    parentId = this.orgInfo.orgProvince || '100';
                    break;
                case 1:
                    this.query.orgCity = this.query.orgArea = this.query.orgTown = ''
                    parentId = this.orgInfo.orgCity;
                    break;
                case 2:
                    this.query.orgArea = this.query.orgTown = ''
                    parentId = this.orgInfo.orgArea;
                    break;
                case 3:
                    this.query.orgTown = ''
                    parentId = this.orgInfo.orgTown;
                    break;
            }
            let list = await this.findChinaPostOrgUnit(
                parentId,
                this.orgInfo.nextOrgType
            );
            if (list.length > 0) {
                this.popList = list;
                if (this.popPage == 0) {
                    this.parentName = '';
                } else {
                    this.popList.forEach((item) => {
                        if (item.id == this.orgInfo.currentId) {
                            item.checked = true;
                            this.parentName = item.name;
                        }
                    });
                }
                this.hasNext = true;
            }
        },
        // 进入下一机构
        async nextPage() {
            let selectedItem = this.getSelectedOrg();
            if (!selectedItem) {
                this.$toast('请先选择机构');
                return;
            }
            const { id, name } = selectedItem;
            this.orgInfo.currentId = id;
            this.orgInfo.currentName = name;
            this.popPage++;
            switch (this.popPage) {
                case 0:
                    this.orgInfo.orgProvince = this.orgInfo.currentId;
                    this.query.orgProvince = this.query.orgCity = this.query.orgArea = this.query.orgTown = ''
                    break;
                case 1:
                    this.query.orgProvince = this.orgInfo.orgCity = this.orgInfo.currentId;
                    this.query.orgCity = this.query.orgArea = this.query.orgTown = ''
                    break;
                case 2:
                    this.query.orgCity = this.orgInfo.orgArea = this.orgInfo.currentId;
                    this.query.orgArea = this.query.orgTown = ''
                    break;
                case 3:
                    this.query.orgArea = this.orgInfo.orgTown = this.orgInfo.currentId;
                    this.query.orgTown = ''
                    break;
            }
            let list = await this.findChinaPostOrgUnit(
                this.orgInfo.currentId,
                this.orgInfo.nextOrgType
            );
            if (list.length > 0) {
                this.popList = list;
                this.parentName = this.orgInfo.currentName;
                if (this.popPage == 0) {
                    this.popText = "所属机构";
                } else {
                    this.popText = "所选机构";
                }
            } else {
                this.popPage--;
                this.$toast("没有更多数据了");
                this.hasNext = false;
                this.parentName = this.orgInfo.currentName;
            }
        },
        // 选择信息
        selectOrg(index) {
            this.popList.forEach((ele) => {
                ele.checked = false;
            });
            this.popList[index].checked = true;
        },
        getSelectedOrg() {//判断是否选中机构
            return this.popList.find((item) => {
                return item.checked;
            })
        },
        confirm() {//确认选择
            let selectedItem = this.getSelectedOrg();
            if (!selectedItem) {
                this.$toast('请先选择机构');
                return;
            }
            const { id, name } = selectedItem;
            this.orgInfo.currentId = id;
            this.query.currentName = this.orgInfo.mecName = this.orgInfo.currentName = name;
            switch (this.popPage) {
                case 0:
                    this.query.orgProvince = this.orgInfo.currentId;
                    this.query.orgCity = this.query.orgArea = this.query.orgTown = ''
                    break;
                case 1:
                    this.query.orgCity = this.orgInfo.currentId;
                    this.query.orgArea = this.query.orgTown = ''
                    break;
                case 2:
                    this.query.orgArea = this.orgInfo.currentId;
                    this.query.orgTown = ''
                    break;
                case 3:
                    this.query.orgTown = this.orgInfo.currentId;
                    break;
            }
            this.popPage++;
            switch (this.popPage) {
                case 0:
                    this.orgInfo.orgProvince = this.orgInfo.currentId;
                    break;
                case 1:
                    this.orgInfo.orgCity = this.orgInfo.currentId;
                    break;
                case 2:
                    this.orgInfo.orgArea = this.orgInfo.currentId;
                    break;
                case 3:
                    this.orgInfo.orgTown = this.orgInfo.currentId;
                    break;
            }
            console.log(this.query);
            this.isShowMec = false
        },
        confirmSelect(){
            this.show = true
        },
        updateUserOrgInfo(){
            let data = {
                identified:this.user.identified || '0',
                orgType:this.query.orgType
            }
            data.orgProvince = this.query.orgProvince;
            data.orgCity = this.query.orgCity;
            data.orgArea = this.query.orgArea;
            data.orgTown = this.query.orgTown;
            console.log(data);
            updateUserOrgInfoApi(data).then((res)=>{
                if (res.returnCode == "0000") {
                    this.$toast("修改成功");
                    this.unionLogin({//重新登录获取信息
                        bscInfo: this.$route.query.bscInfo,
                        sign: this.$route.query.sign,
                        operateOrg: true,
                        orgType:data.orgType,
                        userTrueName:this.query.currentName,
                        orgProvince:data.orgProvince,
                        orgCity:data.orgCity,
                        orgArea:data.orgArea,
                        orgTown:data.orgTown
                    })
                } else {
                    this.$toast( res.returnMessage || "认证失败，请重新尝试");
                }
            })
        },        
        beforeClose(action,done){//机构确认
            if(action === 'confirm'){
                if(!this.orgInfo.currentId){//未选择机构
                    this.$toast('请先选择机构');
                }else{
                    this.updateUserOrgInfo()
                }
                return done(false)
            }
        }
    },
};